import { createFormContext } from "@mantine/form"
import type { CrossbarEvent } from "crossbar/types/crossbar-event.model"

export const [
  CrossbarFormProvider,
  useCrossbarEventFormContext,
  useCrossbarEventForm,
] = createFormContext<Omit<CrossbarEvent, "id">>()
